import { PlatformEnum } from "./platform-enum";

export const platformLabels = {
  [PlatformEnum.POS]: "POS",
  [PlatformEnum.BACK_OFFICE]: "Back Office",
};
